<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m22 6v4c-1.1 0-2 .9-2 2s.9 2 2 2v4c0 1.1-.9 2-2 2h-16c-1.1 0-2-.9-2-2v-4c1.11 0 2-.9 2-2s-.89-2-1.99-2v-4c0-1.1.89-2 1.99-2h16c1.1 0 2 .9 2 2zm-12.92999 10 2.92999-1.88 2.93 1.88-.89-3.36 2.69-2.2-3.47-.21-1.26-3.23-1.27 3.22-3.46999.21 2.69 2.2z"
    />
  </svg>
</template>
